import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import styles from './HamburgerMenu.module.css';
import Button from '../UI/Button';

const HamburgerMenu = () => {
    const [isOpen, setIsOpen] = useState(false);
    const location = useLocation();

    const navItems = [
        { path: '/', label: 'Home' },
        { path: '/services', label: 'Services' },
        { path: '/about', label: 'About' },
        { path: '/contact', label: 'Contact' },
    ];

    const toggleMenu = () => {
        setIsOpen(!isOpen);
    };

    const closeMenu = () => {
        setIsOpen(false);
    };

    return (
        <div className={styles.hamburgerMenu}>
            <button
                className={`${styles.hamburgerButton} ${isOpen ? styles.open : ''}`}
                onClick={toggleMenu}
                aria-label="Toggle menu"
                aria-expanded={isOpen}
            >
                <span className={styles.hamburgerBar}></span>
                <span className={styles.hamburgerBar}></span>
                <span className={styles.hamburgerBar}></span>
            </button>

            <div className={`${styles.menu} ${isOpen ? styles.open : ''}`}>
                <nav className={styles.menuNav}>
                    <ul className={styles.menuList}>
                        {navItems.map((item) => (
                            <li key={item.path}>
                                <Link
                                to={item.path}
                                className={`${styles.menuLink} ${
                                    location.pathname === item.path ? styles.active : ''
                                }`}
                                onClick={closeMenu}
                                >
                                    {item.label}
                                </Link>
                            </li>
                        ))}
                    </ul>
                    
                    {/* Get Started Button in Mobile Menu */}
                    <div className={styles.mobileCta}>
                        <Button
                        as={Link}
                        to="/contact"
                        variant="primary"
                        size="large"
                        onClick={closeMenu}
                        className={styles.mobileCtaButton}
                        >
                            Get Started
                        </Button>
                    </div>
                </nav>
            </div>

            {isOpen && (
                <div className={styles.overlay} onClick={closeMenu}></div>
            )}
        </div>
    );
};

export default HamburgerMenu;